<template>
  
    <v-dialog v-model="modalComputed" persistent scrollable max-width="780">
      <v-card flat>

        <v-toolbar flat color="accent">
          <v-btn icon @click="modalComputed = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Certificado Digital - Empresa {{ filial.cc_fil }}</v-toolbar-title>
        </v-toolbar>

        <v-card-text class="ma-0 pa-0">
          <v-container>
            <v-row>
              <v-col>
                <div v-if="requerente == undefined || requerente == ''">
                  <v-alert text type="info" color="primary">N&atilde;o h&aacute; certificado digital configurado para esta empresa</v-alert>
                </div>
                <div v-else>
                  <b>Requerente:</b> {{ requerente }}<br />
                  <b>Validade:</b> {{ validade }}
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-card outlined>
                  <v-card-text>
                    <div class="d-flex flex-column">
                      <div class="d-flex flex-row">
                            <v-file-input ref="certificado" label="Arquivo" v-model="arquivo" class="mr-2"></v-file-input>
                            <v-text-field
                              v-model="senha"
                              :append-icon="exibeSenha ? 'mdi-eye' : 'mdi-eye-off'"
                              :type="exibeSenha ? 'text' : 'password'"
                              name="senha"
                              label="Senha"
                              @click:append="exibeSenha = !exibeSenha"></v-text-field>
                      </div>
                    </div>
                    <v-btn depressed outlined color="primary" @click="salvar()" :disabled="arquivo == undefined || arquivo == ''">SALVAR</v-btn>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  
</template>
<script>
export default {

  name: 'Certificado',
  
  data() {
      return {
        requerente: undefined,
        validade: undefined,
        senha: '',
        exibeSenha: false,
        filial: undefined,
        arquivo: undefined,

        filialIdTemp: undefined,
        modalTemp: undefined
      }
  },
  
  props: {

    filialId: {
      required: true
    },

    modal: {
      required: true
    },

  },

  methods: {

    salvar() {

      const formData = new FormData();
      formData.append("arquivo", this.arquivo);
      formData.append("cc_fil", this.filial.cc_fil)
      formData.append("cc_sen_cer", this.senha)
      
      this.$store.dispatch('salvarCertificado', formData).then(() => {
        this.arquivo = undefined
        this.senha = ''
        this.obterFilial()
      }).catch()
      
    },

    setarArquivo() {
      this.arquivo = this.$refs.certificado.files[0]
    },

    obterCertificado(certificadoId){
      this.$store.dispatch('obterCertificado', certificadoId).then((resp) => {
        this.requerente = resp.data.tx_requerente
        this.validade = resp.data.dt_ven
      }).catch()
    },

    obterFilial() {
      if(this.filialIdComputed != undefined) {
        this.$store.dispatch('obterFilial', this.filialIdComputed).then((resp) => {
          this.filial = resp.data
          if(this.filial.certificados !== undefined && this.filial.certificados.length > 0) {
            this.obterCertificado(this.filial.certificados[0].id_reg)
          }
        }).catch()
      }
    },

  },

  computed: {
    modalComputed :  {
      get: function() { 
        return this.modalTemp
      },
      set: function(value) {
        this.modalTemp = value
      }
    },
    filialIdComputed: {
      get: function() { 
        return this.filialIdTemp
      },
      set: function(value) {
        this.filialIdTemp = value
      }
    }
  },

  mounted: function() {
    this.obterFilial()
  },

  created: function() {
    this.modalComputed = this.modal
    this.filialIdComputed = this.filialId
    this.$emit('a')
  }

}
</script>